import { useQuery } from '@tanstack/react-query';
import { useMe } from './useAuth';
import { api } from '@/lib/api';

export interface ParentCourseContext {
  href: string;
  title: string;
  lesson_title: string;
  mission_title: string;
  content_md: string | null;
}
/** A return hint is navigation only; ownership and entitlement are always checked by the API. */
export function parentCourseReturnTo(search: string): string | null {
  const href = new URLSearchParams(search).get('course');
  return href && /^\/portal\/learning\/(classes|self-paced)\/[A-Za-z0-9_-]+$/.test(href)
    ? href
    : null;
}
export function useParentCourseContext(projectId: string | undefined, enabled: boolean) {
  const me = useMe('user', enabled);
  const owner = me.data?.kind === 'user' ? me.data.sub : null;
  return useQuery({
    queryKey: ['parent-courses', owner, 'project-context', projectId],
    queryFn: () =>
      api<ParentCourseContext | null>(
        `/parent-courses/projects/${encodeURIComponent(projectId!)}/context`,
        { principal: 'user' },
      ),
    enabled: enabled && !!owner && !!projectId && projectId !== 'new',
  });
}
